import { CompanyUrlService } from './company-url/company-url.service';

export { CompanyUrlService };

export default [CompanyUrlService];
